/**
 * TEST VERSIONS kept on this device (no server side yet - PLAN.md §5): the nickname and "last sign-in".
 * Keys are per fan id, so two people on one browser don't see each other's.
 */
const safe = <T,>(f: () => T, fallback: T) => { try { return f() } catch { return fallback } }

export const nick = {
  get: (uid?: string | null) => (uid ? safe(() => localStorage.getItem(`cw-nick:${uid}`) || '', '') : ''),
  set: (uid: string, v: string) => safe(() => (v ? localStorage.setItem(`cw-nick:${uid}`, v) : localStorage.removeItem(`cw-nick:${uid}`)), undefined),
  asked: (uid?: string | null) => (uid ? safe(() => localStorage.getItem(`cw-nick-asked:${uid}`) === '1', true) : true),
  markAsked: (uid: string) => safe(() => localStorage.setItem(`cw-nick-asked:${uid}`, '1'), undefined),
}

/** Call once per visit: returns the previous visit's time on this device (or null the first time). */
export function noteSignIn(uid: string): string | null {
  return safe(() => {
    const seenKey = `cw-visit-noted:${uid}`
    if (sessionStorage.getItem(seenKey)) return localStorage.getItem(`cw-prev-visit:${uid}`)
    const last = localStorage.getItem(`cw-last-visit:${uid}`)
    if (last) localStorage.setItem(`cw-prev-visit:${uid}`, last)
    localStorage.setItem(`cw-last-visit:${uid}`, new Date().toISOString())
    sessionStorage.setItem(seenKey, '1')
    return last
  }, null)
}
export function lastSignInText(iso: string | null) {
  if (!iso) return 'First sign-in on this device'
  const d = new Date(iso)
  return `Last sign-in: ${d.toLocaleDateString('en-US', { weekday: 'short' })}, ${d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`
}
